import styled from 'styled-components';

type Props = {
  alpha?: number;
  offset?: number;
};

export const CustomDividerWrapper = styled.div<Props>`
  opacity: ${props => props.alpha};
  padding: ${props => props.offset}px 0;
`;
